/* global Office */

/**
 * utils/prefs.js
 * Persistance des préférences utilisateur via Office.context.roamingSettings
 * (suit l'utilisateur entre appareils). Fallback localStorage hors Outlook.
 */

const PREFS_KEY = "acomail.prefs";
const SUPPORTED_LANGS = ["fr", "en", "de"];

export const DEFAULT_ACCENT_COLOR = "#0BBCC1";

export const DEFAULT_PREFS = {
  uiLang: "en",
  replyLang: "en",
  tone: "direct",
  length: "medium",
  accentColor: DEFAULT_ACCENT_COLOR,
};

function getRoamingStore() {
  return window.Office?.context?.roamingSettings ?? null;
}

function detectOutlookLang() {
  const raw = window.Office?.context?.displayLanguage;
  if (!raw) return null;
  const code = String(raw).slice(0, 2).toLowerCase();
  return SUPPORTED_LANGS.includes(code) ? code : null;
}

function withDefaults(saved) {
  const outlookLang = detectOutlookLang();
  const base = outlookLang
    ? { ...DEFAULT_PREFS, uiLang: outlookLang, replyLang: outlookLang }
    : DEFAULT_PREFS;
  return { ...base, ...(saved || {}) };
}

export function loadPrefs() {
  const store = getRoamingStore();
  if (store) {
    return withDefaults(store.get(PREFS_KEY));
  }
  try {
    const raw = window.localStorage?.getItem(PREFS_KEY);
    if (raw) return withDefaults(JSON.parse(raw));
  } catch {
    // ignore corrupted storage
  }
  return withDefaults(null);
}

export function savePrefs(prefs) {
  const payload = { ...DEFAULT_PREFS, ...prefs };
  const store = getRoamingStore();
  if (store) {
    store.set(PREFS_KEY, payload);
    store.saveAsync();
    return;
  }
  try {
    window.localStorage?.setItem(PREFS_KEY, JSON.stringify(payload));
  } catch {
    // ignore quota / unavailable storage
  }
}
